export const transformDataForEmbeddedMacros = (
	key: string,
	embeddedMacroLocalId: string | undefined,
	data: any,
): any => {
	if (key === 'getMacroContent' || key === 'updateMacroContent') {
		return {
			...(typeof data === 'object' ? data : {}),
			embeddedMacroLocalId,
		};
	}
	return data;
};
